namespace GeniuzPOS.InitialData {
    export enum PsPosStationEumConnectRFIDReaderFg {
        ConnectRFIDReaderFgNo = 0,
        ConnectRFIDReaderFgYes = 1
    }
    Serenity.Decorators.registerEnumType(PsPosStationEumConnectRFIDReaderFg, 'GeniuzPOS.InitialData.PsPosStationEumConnectRFIDReaderFg');
}
